const getRuntimeFeatureValues = (publicRuntimeConfig)=>{
    var ref;
    var ref1;
    const enabledFeatures = (ref1 = publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : (ref = publicRuntimeConfig.grandvision) === null || ref === void 0 ? void 0 : ref.features) !== null && ref1 !== void 0 ? ref1 : [];
    const myAccount = isFeatureEnabled(enabledFeatures, 'MYACCOUNT');
    return {
        myAccount
    };
};
const isFeatureEnabled = (enabledFeatures, feature)=>{
    return enabledFeatures.includes(feature);
};

export { getRuntimeFeatureValues };
//# sourceMappingURL=get-runtime-feature-values.js.map
